import Marquee from "react-fast-marquee";

const ITEMS = [
  "FULLY INSURED",
  "12+ YEARS EXPERIENCE",
  "24/7 EMERGENCY CALLOUT",
  "FREE NO-OBLIGATION QUOTES",
  "DOMESTIC & COMMERCIAL",
  "5.0 STAR RATED",
];

export const TrustMarquee = () => (
  <div className="border-y border-hairline bg-void py-5 select-none" data-testid="trust-marquee">
    <Marquee speed={38} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center font-heading uppercase tracking-tight text-2xl sm:text-3xl text-stark mx-8">
          {t}
          <span className="mx-8 text-brand text-3xl leading-none">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
